import React, { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const MessageContextProvider = ({ children }) => {
  const [usuarioLogado, setUsuarioLogado] = useState("");
  /* SERVIÇOS DE ACOLHIMENTO */
  const [editarServicoServ, setEditarServicoServ] = useState(false);
  const [cadastrarPerfilServ, setCadastrarPerfilServ] = useState(false);
  const [editarPerfilServ, setEditarPerfilServ] = useState(false);
  const [cadastrarGestaoServ, setCadastrarGestaoServ] = useState(false);
  const [editarGestaoServ, setEditarGestaoServ] = useState(false);
  const [cadastrarRegularidadeServ, setCadastrarRegularidadeServ] =
    useState(false);
  const [editarRegularidadeServ, setEditarRegularidadeServ] = useState(false);
  const [cadastrarPlanejamentoServ, setCadastrarPlanejamentoServ] =
    useState(false);
  const [editarPlanejamentoServ, setEditarPlanejamentoServ] = useState(false);
  const [cadastrarEquipeServ, setCadastrarEquipeServ] = useState(false);
  const [editarEquipeServ, setEditarEquipeServ] = useState(false);
  const [cadastrarRedeServ, setCadastrarRedeServ] = useState(false);
  const [cadastrarApadrinhamentoServ, setCadastrarApadrinhamentoServ] =
    useState(false);
  const [editarApadrinhamentoServ, setEditarApadrinhamentoServ] =
    useState(false);
  const [editarRedeServ, setEditarRedeServ] = useState(false);
  const [cadastrarVoluntariadoServ, setCadastrarVoluntariadoServ] =
    useState(false);
  const [editarVoluntariadoServ, setEditarVoluntariadoServ] = useState(false);
  const [cadastrarPenaServ, setCadastrarPenaServ] = useState(false);
  const [editarPenaServ, setEditarPenaServ] = useState(false);
  const [cadastrarAnexo, setCadastrarAnexo] = useState(false);

  /* CRIANÇA E ADOLESCENTE */
  const [filiacaoEditarCr, setFiliacaoEditarCr] = useState(false);
  const [filiacaoCadastrarCr, setFiliacaoCadastrarCr] = useState(false);
  const [editarCriancaCr, setEditarCriancaCr] = useState(false);
  const [cadastrarDocCrianca, setCadastrarDocCrianca] = useState(false);
  const [editarDocCrianca, setEditarDocCrianca] = useState(false);
  const [cadastrarSaudeCrianca, setCadastrarSaudeCrianca] = useState(false);
  const [editarSaudeCrianca, setEditarSaudeCrianca] = useState(false);
  const [cadastrarProfCrianca, setCadastrarProfCrianca] = useState(false);
  const [editarProfCrianca, setEditarProfCrianca] = useState(false);
  const [cadastrarEducCrianca, setCadastrarEducCrianca] = useState(false);
  const [editarEducCrianca, setEditarEducCrianca] = useState(false);
  const [cadastrarOcorCrianca, setCadastrarOcorCrianca] = useState(false);
  const [editarOcorCrianca, setEditarOcorCrianca] = useState(false);
  const [cadastrarRefFamiliar, setCadastrarRefFamiliar] = useState(false);
  const [editarRefFamiliar, setEditarRefFamiliar] = useState(false);
  const [cadastrarIrmao, setCadastrarIrmao] = useState(false);
  const [editarIrmao, setEditarIrmao] = useState(false);
  const [cadastrarGuarda, setCadastrarGuarda] = useState(false);
  const [cadastrarVisita, setCadastrarVisita] = useState(false);
  const [cadastrarRestricao, setCadastrarRestricao] = useState(false);
  const [editarRestricaoVisita, setEditarRestricaoVisita] = useState(false);
  const [cadastrarProcessosProcedimentos, setCadastrarProcessosProcedimentos] =
    useState(false);
  const [cadastrarApadrinhamentoCrianca, setCadastrarApadrinhamentoCrianca] =
    useState(false);
  const [editarApadrinhamentoCrianca, setEditarApadrinhamentoCrianca] =
    useState(false);

  const [atualizarDocumentacao, setAtualizarDocumentacao] = useState(false);
  const [cadastrarDocumentacao, setCadastrarDocumentacao] = useState(false);
  const [filiacao, setFiliacao] = useState([]);
  const [situacaoMovimento, setSituacaoMovimento] = useState("");
  const [movimentacoesPendente, setMovimentacoesPendente] = useState(false);
  const [situacao, setSituacao] = useState("");
  const [atualizarEducacao, setAtualizarEducacao] = useState(false);
  const [cadastrarEducacao, setCadastrarEducacao] = useState(false);

  const [atualizarOcorrencia, setAtualizarOcorrencia] = useState(false);
  const [cadastrarOcorrencia, setCadastrarOcorrencia] = useState(false);
  const [atualizarProfissionalizacao, setAtualizarProfissionalizacao] =
    useState(false);
  const [cadastrarProfissionalizacao, setCadastrarProfissionalizacao] =
    useState(false);
  const [atualizarSaude, setAtualizarSaude] = useState(false);
  const [cadastrarSaude, setCadastrarSaude] = useState(false);

  const [atualizarApadrinhamento, setAtualizarApadrinhamento] = useState(false);
  const [cadastrarApadrinhamento, setCadastrarApadrinhamento] = useState(false);

  const [possuiOcorrencia, setPossuiOcorrencia] = useState(false);
  const [anexarCrianca, setAnexarCrianca] = useState(false);
  const [editarAnexoCrianca, setEditarAnexoCrianca] = useState(false);

  const [primeiraMovimentacao, setPrimeiraMovimentacao] = useState();
  const [ultimaMovimentacao, setUltimaMovimentacao] = useState();
  const [houveExtincaoPoderFamiliar, setHouveExtincaoPoderFamiliar] =
    useState(false);

  const [idPessoaFisicaFilho, setIdPessoaFisicaFilho] = useState(null);
  const [ultimaMovimentacaoBuscar, setUltimaMovimentacaoBuscar] = useState();

  const [radioClick, setRadioClick] = useState("");

  const [idPJ, setIdPJ] = useState(null);
  const [idPromotoriaAtribuicao, setIdPromotoriaAtribuicao] = useState(null);

  const [irmaoCadatrar, setIrmaoCadatrar] = useState(null);

  const [movimentacaoData, setMovimentacaoData] = useState(null);
  const [movimentacaoDataAnterior, setMovimentacaoDataAnterior] =
    useState(null);
  const [movimentacaoDataPosterior, setMovimentacaoDataPosterior] =
    useState(null);
  const [movimentacaoEditar, setMovimentacaoEditar] = useState(false);
  const [movimentacaoIsFirst, setMovimentacaoIsFirst] = useState(false);
  const [crianca, setCrianca] = useState(null);
  const [servicoData, setServicoData] = useState(null);

  const contextValue = {
    usuarioLogado,
    setUsuarioLogado,
    idPromotoriaAtribuicao,
    setIdPromotoriaAtribuicao,
    servicoData,
    setServicoData,
    crianca,
    setCrianca,
    movimentacoesPendente,
    setMovimentacoesPendente,
    atualizarApadrinhamento,
    setAtualizarApadrinhamento,
    cadastrarApadrinhamento,
    setCadastrarApadrinhamento,
    editarApadrinhamentoCrianca,
    setEditarApadrinhamentoCrianca,
    cadastrarApadrinhamentoCrianca,
    setCadastrarApadrinhamentoCrianca,
    cadastrarApadrinhamentoServ,
    setCadastrarApadrinhamentoServ,
    editarApadrinhamentoServ,
    setEditarApadrinhamentoServ,
    filiacaoCadastrarCr,
    setFiliacaoCadastrarCr,
    filiacaoEditarCr,
    setFiliacaoEditarCr,
    editarAnexoCrianca,
    setEditarAnexoCrianca,
    anexarCrianca,
    setAnexarCrianca,
    radioClick,
    setRadioClick,
    houveExtincaoPoderFamiliar,
    setHouveExtincaoPoderFamiliar,
    cadastrarProcessosProcedimentos,
    setCadastrarProcessosProcedimentos,
    editarIrmao,
    setEditarIrmao,
    cadastrarIrmao,
    setCadastrarIrmao,
    idPessoaFisicaFilho,
    setIdPessoaFisicaFilho,
    ultimaMovimentacaoBuscar,
    setUltimaMovimentacaoBuscar,
    ultimaMovimentacao,
    setUltimaMovimentacao,
    primeiraMovimentacao,
    setPrimeiraMovimentacao,
    possuiOcorrencia,
    setPossuiOcorrencia,
    atualizarSaude,
    setAtualizarSaude,
    cadastrarSaude,
    setCadastrarSaude,
    atualizarProfissionalizacao,
    setAtualizarProfissionalizacao,
    cadastrarProfissionalizacao,
    setCadastrarProfissionalizacao,
    cadastrarOcorrencia,
    setCadastrarOcorrencia,
    atualizarOcorrencia,
    setAtualizarOcorrencia,
    cadastrarEducacao,
    setCadastrarEducacao,
    atualizarEducacao,
    setAtualizarEducacao,
    cadastrarDocumentacao,
    setCadastrarDocumentacao,
    atualizarDocumentacao,
    setAtualizarDocumentacao,
    cadastrarVisita,
    setCadastrarVisita,
    cadastrarRestricao,
    setCadastrarRestricao,
    editarRestricaoVisita,
    setEditarRestricaoVisita,
    cadastrarGuarda,
    setCadastrarGuarda,
    cadastrarRefFamiliar,
    setCadastrarRefFamiliar,
    editarRefFamiliar,
    setEditarRefFamiliar,
    cadastrarOcorCrianca,
    setCadastrarOcorCrianca,
    editarOcorCrianca,
    setEditarOcorCrianca,
    cadastrarEducCrianca,
    setCadastrarEducCrianca,
    editarEducCrianca,
    setEditarEducCrianca,
    cadastrarProfCrianca,
    setCadastrarProfCrianca,
    cadastrarSaudeCrianca,
    setCadastrarSaudeCrianca,
    editarProfCrianca,
    setEditarProfCrianca,
    editarSaudeCrianca,
    setEditarSaudeCrianca,
    editarCriancaCr,
    cadastrarDocCrianca,
    setCadastrarDocCrianca,
    setEditarCriancaCr,
    editarServicoServ,
    setEditarServicoServ,
    cadastrarPerfilServ,
    setCadastrarPerfilServ,
    editarPerfilServ,
    setEditarPerfilServ,
    cadastrarGestaoServ,
    editarGestaoServ,
    cadastrarRegularidadeServ,
    editarRegularidadeServ,
    cadastrarPlanejamentoServ,
    editarPlanejamentoServ,
    cadastrarEquipeServ,
    editarEquipeServ,
    cadastrarRedeServ,
    editarRedeServ,
    cadastrarVoluntariadoServ,
    editarVoluntariadoServ,
    cadastrarPenaServ,
    editarPenaServ,
    cadastrarAnexo,
    setCadastrarAnexo,
    setEditarGestaoServ,
    setCadastrarGestaoServ,
    setEditarRegularidadeServ,
    setCadastrarRegularidadeServ,
    setCadastrarPlanejamentoServ,
    setCadastrarEquipeServ,
    setCadastrarRedeServ,
    setEditarPlanejamentoServ,
    setCadastrarVoluntariadoServ,
    setCadastrarPenaServ,
    setEditarEquipeServ,
    setEditarRedeServ,
    setEditarVoluntariadoServ,
    setEditarPenaServ,
    editarDocCrianca,
    setEditarDocCrianca,
    filiacao,
    setFiliacao,
    setSituacaoMovimento,
    situacaoMovimento,
    setSituacao,
    situacao,
    idPJ,
    setIdPJ,
    irmaoCadatrar,
    setIrmaoCadatrar,
    movimentacaoData,
    setMovimentacaoData,
    movimentacaoDataAnterior,
    setMovimentacaoDataAnterior,
    movimentacaoEditar,
    setMovimentacaoEditar,
    movimentacaoIsFirst,
    setMovimentacaoIsFirst,
    movimentacaoDataPosterior,
    setMovimentacaoDataPosterior,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
